import { MultiValue } from "react-select";
import { BinInfo } from "../staticInfo/state";

export type RouteState = {
    collectorList: CollectorInfo[] | null;
    selectedBinInfo: MultiValue<BinInfo> | null;
    route_name: string;
    collector_id: string | null;
    weekday:string,
    remark: string;
    effective_day: moment.Moment | Date | null;
    create_date: string | null
    update_date: string | null
    routeDetail: RouteDetail[]|[];
    routeList: RouteState[]|[],
    RouteCollectionList:RouteCollectionInfo[]| []
    route_id?:number| null
    
};

export type CollectorInfo = {
    user_id: string;
    username: string;
};

export type RouteCollectionInfo={
    route_id:string,
    route_name:string,
    username:string,
    is_active:number
}

export interface RouteDetail {
    route_detail_id: number;
    sequence: number;
    bin_full_name: string;
    username: string;
}




export const routeState: RouteState = {
    collectorList: null,
    selectedBinInfo: null,
    route_name: "",
    collector_id: "",
    weekday:"",
    remark: "",
    effective_day: null,
    create_date:null,
    update_date:null,
    routeList:[],
    routeDetail:[],
    RouteCollectionList:[],
    route_id:null
};
